import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {useStickerStore} from './sticker-store'

const TwStickerItemTitle = tw.div<{$isBold: boolean}>`
  ${({$isBold}) => ($isBold ? 'font-semibold' : '')}
  flex
  items-center
`

export const StickerItemTitle = observer(() => {
  const [state, store] = useStickerStore()

  let title = state.displayedTitle
  if (!React.isValidElement(title)) {
    title = <div className="truncate">{title}</div>
  }

  return (
    <TwStickerItemTitle $isBold={!!store.titleIsBold}>
      {title}
    </TwStickerItemTitle>
  )
})
